import { render, staticRenderFns } from "./TicketStatusEdit.vue?vue&type=template&id=25b5074e&scoped=true"
import script from "./TicketStatusEdit.vue?vue&type=script&lang=js"
export * from "./TicketStatusEdit.vue?vue&type=script&lang=js"
import style0 from "./TicketStatusEdit.vue?vue&type=style&index=0&id=25b5074e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b5074e",
  null
  
)

export default component.exports